import { Moment } from "moment";
import { DocumentClass } from "./documentClass";

export enum BatchStatus {
  DRAFT = 'DRAFT',
  OPENED = 'OPENED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  PROCESSED = 'PROCESSED',
  ERROR = 'ERROR'
}

export enum BatchMode {
  GENERIC = 'GENERIC',
  TRADEMARKS = 'TRADEMARKS',
  COUNTRIES = 'COUNTRIES',
  NON_USE = 'NON_USE'
}

export enum BatchDocumentStatus {
  OK = 'OK',
  ERROR = 'ERROR',
  NO_TRADEMARK = 'NO_TRADEMARK',
  NO_TERRITORY = 'NO_TERRITORY',
  NO_DATE = 'NO_DATE',
  NO_NICE_CLASSIFICATION = 'NO_NICE_CLASSIFICATION',
  MISMATCH_NICE_CLASSIFICATION = 'MISMATCH_NICE_CLASSIFICATION',
  MISMATCH_TERRITORY = 'MISMATCH_TERRITORY'
}

// statuses during which the batch page shows the auto-refresh state
export const ACTIVE_BATCH_STATUSES: Readonly<BatchStatus[]> = [
  BatchStatus.PENDING,
  BatchStatus.PROCESSING,
];

export interface Batch {
  _id?: string;
  number: number;
  status: BatchStatus;
  mode: BatchMode;
  modeRestrictive?: boolean;
  documents: number;
  report: {
    ok: number;
    warning: number;
    error: number;
    score?: number;
  }
  trademarks?: [
    {
      ref: string;
      name: string;
      identifierNumber: string;
      countryOfDesignation: string;
    }
  ],
  countries?: string[],
  uploader: {
    ref: string;
    firstName: string;
    lastName: string;
    avatar: string;
  };
  technical: {
    cost: number;
    time: number;
  };
  organizationId: string;
  createdAt: Moment;
  lastAnalyzedAt?: string;
}

export interface BatchPopulatedDocument {
  _id: string;
  name: string;
  type: string;
  class: DocumentClass;
  status: BatchDocumentStatus[];
  // Whether there is an analysis result yet: `status` reads as every datum missing before the analysis.
  analysis?: 'NOT_ANALYZED' | 'EXCLUDED' | 'ANALYZING' | 'ANALYZED';
  nonUse: boolean;
}
